import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=81eaa264&"
import script from "./ButtonBase.vue?vue&type=script&lang=js&"
export * from "./ButtonBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports